import React from 'react';
import RegistrationLayout from 'shared/components/Layouts/RegistrationPageLayout';
import TermsSections from 'features/RegistrationContainer/components/TermsAndConditions/TermsSections';
import InformationContainer from 'features/RegistrationContainer/components/InformationContainer';

const ViewTermAndCondition = () => {
  return (
    <RegistrationLayout>
      <InformationContainer>
        <TermsSections />
      </InformationContainer>
     
    </RegistrationLayout>
  );
};

export default ViewTermAndCondition;